import { useState } from 'react';
import { Control, useController, useWatch } from 'react-hook-form';
import { SchemaSection } from '@rossum/api-client/schemas';
import { FormulaFieldSection } from '../../../../formulas/FormulaFieldSection/FormulaFieldSection';
import { FormulaFieldsSurvey } from '../../../../surveys/FieldsSurveys/FormulaFieldsSurvey';
import { FieldsFormValues } from '../../form-model/formModels';

type FormulaSectionProps = {
  control: Control<FieldsFormValues> | undefined;
  schemaContent: SchemaSection[];
};

export const FormulaSection = ({
  control,
  schemaContent,
}: FormulaSectionProps) => {
  const formulaSchemaId = useWatch({ control, name: 'field.id' });
  const formulaLabel = useWatch({ control, name: 'field.label' });
  const [focused, setFocused] = useState(false);

  const { field, fieldState } = useController({
    control,
    name: 'field.formula',
  });

  return (
    <>
      <FormulaFieldsSurvey focused={focused} />
      <FormulaFieldSection
        schemaContent={schemaContent}
        formulaSchemaId={formulaSchemaId}
        onChange={() => {
          setFocused(true);
        }}
        fieldState={fieldState}
        field={field}
        disabled={!formulaSchemaId || !formulaLabel}
      />
    </>
  );
};
